import React from 'react';
import { serviceAPI } from '../../InterfaceAPI/serviceAPI';
import withSplashMessage from '../splashMessage/withSplashMessage';
import { stringfyServerErrors } from '../../helpers/util';
import Spinner from '../shared/Spinner';
import {
  maskServiceDate,
  maskServiceStartTime,
  maskServiceEndTime
} from '../../masks';

class ClientServiceSkip extends React.Component {
  state = {
    loadingService: true,
    service: null,
    error: null,
  };

  componentDidMount() {
    const token = this.props.match.params.token;

    serviceAPI.skipServiceWithToken(token)
      .then((res) => {
        this.setState({
          loadingService: false,
          service: res.service
        });
      })
      .catch((err) => {
        this.setState({
          loadingService: false,
          error: stringfyServerErrors(err),
        });
      });
  }

  render() {
    return (
      <div className="chef">
        <div className="confirm-service">
          <div className="confirm-service-inner">
            <Spinner isRequestOut={this.state.loadingService} />
            {this.state.service && (
              <div>
                <h1 className="form__service-skip">Service Successfully Skipped!</h1>
                <table style={{width: '100%'}}>
                  <tr>
                    <td className="p">Service Date:</td>
                    <td className="p">
                      {maskServiceDate(this.state.service.start_time)}
                    </td>
                  </tr>
                  <tr>
                    <td className="p">Service Time:</td>
                    <td className="p">
                      <p>
                        {maskServiceStartTime(this.state.service.start_time)} 
                        {maskServiceEndTime(this.state.service.end_time)}
                      </p>
                    </td>
                  </tr>
                </table>
              </div>
            )}
            {this.state.error && (
              <div>
                <h1 className="form__service-skip">Error</h1>
                <p className='p'>{this.state.error}</p>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default withSplashMessage(ClientServiceSkip);



// WEBPACK FOOTER //
// ./src/components/chef/ClientServiceSkip.js